import { Poly } from "../../Poly";
import { CoreGraphNode } from "../../../core/graph/CoreGraphNode";
export class SceneCamerasController {
  constructor(scene) {
    this.scene = scene;
    this._cameraObjectsRecentlyUpdated = [];
    this._coreGraphNode = new CoreGraphNode(this.scene, "SceneCamerasController");
  }
  coreGraphNode() {
    return this._coreGraphNode;
  }
  updateFromChangeInObject(object) {
    this._cameraObjects(object, this._cameraObjectsRecentlyUpdated);
    if (this._cameraObjectsRecentlyUpdated.length > 0) {
      this._coreGraphNode.setDirty();
    }
    if (this._onCameraObjectsUpdated) {
      this._onCameraObjectsUpdated();
    }
  }
  cameraObjects() {
    const objects = [];
    this._cameraObjects(this.scene.threejsScene(), objects);
    return objects;
  }
  _cameraObjects(parent, cameraObjects) {
    cameraObjects.splice(0, cameraObjects.length);
    parent.traverse((object) => {
      if (Poly.camerasRegister.objectRegistered(object)) {
        cameraObjects.push(object);
      }
    });
  }
  cameraObjectsRecentlyUpdated() {
    return this._cameraObjectsRecentlyUpdated;
  }
  setMainCamera(camera) {
    this.scene.root().mainCameraController.setCamera(camera);
  }
  setMainCameraPath(path) {
    this.scene.root().mainCameraController.setCameraPath(path);
  }
  mainCameraPath() {
    return this.scene.root().mainCameraController.rawCameraPath();
  }
  async mainCamera(options) {
    const camera = await this.scene.root().mainCameraController.camera();
    if (camera) {
      return camera;
    }
    let findAnyCamera = true;
    if ((options == null ? void 0 : options.findAnyCamera) != null) {
      findAnyCamera = options.findAnyCamera;
    }
    if (findAnyCamera) {
      return this._findAnyCameraObject();
    }
    return null;
  }
  _findAnyCameraObject() {
    return this.cameraObjects()[0];
  }
  async createMainViewer(options) {
    const mainCamera = await this.mainCamera();
    if (!mainCamera) {
      return;
    }
    return Poly.camerasRegister.createViewer({ ...options, camera: mainCamera, scene: this.scene });
  }
  onCameraObjectsUpdated(callback) {
    this._onCameraObjectsUpdated = callback;
  }
}
